export const EVEN_PREFERENCE = 'Even';

const COUNTS_STORAGE_KEY = 'fertwork-incubator-counts';
const ORDER_STORAGE_KEY = 'fertwork-incubator-order';

export type IncubatorSelection = {
  incubatorCounts: Record<string, number>;
  preferenceOrder: string[];
};

export const getStoredIncubatorSelection = (): IncubatorSelection => {
  let incubatorCounts: Record<string, number>;
  let preferenceOrder: string[];
  try {
    incubatorCounts = JSON.parse(
      localStorage.getItem(COUNTS_STORAGE_KEY) || '{}',
    );
  } catch {
    incubatorCounts = {};
  }
  try {
    preferenceOrder = JSON.parse(
      localStorage.getItem(ORDER_STORAGE_KEY) || '[]',
    );
  } catch {
    preferenceOrder = [];
  }
  return { incubatorCounts, preferenceOrder };
};

export const setStoredIncubatorSelection = ({
  incubatorCounts,
  preferenceOrder,
}: IncubatorSelection) => {
  localStorage.setItem(COUNTS_STORAGE_KEY, JSON.stringify(incubatorCounts));
  localStorage.setItem(ORDER_STORAGE_KEY, JSON.stringify(preferenceOrder));
};
